<div class="removal-modal">
  <h1 class="removal-modal__header">
    Remove {{ data.fileType || 'certificate' }}
  </h1>
  <div class="removal-modal__info">
    Are you sure you want to remove
    <span class="font-bold">{{ data.fileName }}</span
    >?
  </div>
  <div class="removal-modal__row">
    <div class="removal-modal__row__button">
      <ui-button
        (handleClick)="closeModal($event, false)"
        [isSecondary]="true"
        buttonClassName="button-full-width"
        buttonId="removal-modal-close"
        buttonText="Cancel"
        gtmTag="removal-modal-close"
      ></ui-button>
    </div>
    <div class="removal-modal__row__button">
      <ui-button
        (handleClick)="closeModal($event, true)"
        [isSecondary]="false"
        buttonClassName="button-full-width"
        buttonId="removal-modal-confirm-remove"
        buttonText="Remove"
        gtmTag="removal-modal-confirm-remove"
      ></ui-button>
    </div>
  </div>
</div>
